import "./App.css";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

/*import Register from "./components/Register/Register";
import InfoRegister from "./components/Register/InfoRegister";
import ConsentPdpa from "./components/Register/ConsentPdpa";
*/
import Signin from "./components/Signin";
import SigninNotRegister from "./components/SigninNotRegister";
import Lobby from "./components/Lobby";
import MyReward from "./components/MyReward";
import BiggyDunkTank from "./components/Games/BiggyDunkTank";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/:lang/signin" element={<Signin />} />
          <Route path="/:lang/signin-store" element={<SigninNotRegister />} />

          <Route path="/:lang/lobby" element={<Lobby />} />
          <Route path="/:lang/my-reward" element={<MyReward />} />

          <Route
            path="/:lang/biggy-dunk-tank/:game_id"
            element={<BiggyDunkTank />}
          />

         {/*  <Route path="/:lang/register" element={<Register />} />
          <Route path="/:lang/information" element={<InfoRegister />} />
          <Route
            path="/:lang/information/:code_id"
            element={<InfoRegister />}
          />
          <Route path="/:lang/privacy-policy" element={<ConsentPdpa />} />
          */}


          <Route path="/:lang/" element={<Navigate to="/en/signin" />} />
           {/* <Route path="/signin" element={<Navigate to="/en/signin" />} />
          <Route path="/signin-store" element={<Navigate to="/en/SigninNotRegister" />} />          */}
          <Route path="/lobby" element={<Navigate to="/en/lobby" />} />
          <Route path="/my-reward" element={<Navigate to="/en/my-reward" />} />
          <Route path="/*" element={<Navigate to="/en/signin" />} />
          <Route path="/" element={<Navigate to="/en/signin" />} />
        </Routes>
      </div>
    </Router>
  );
  /*
  const token = sessionStorage.getItem('accessToken');
  
  if ((!token) || (token == 'undefined')) {
    return (
      <div className="App">
        <Liff />
      </div>  
    );
  } else {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CouponsList />} />
            <Route exact path="/liff" element={<Liff />} />
            <Route path="/loading" element={<Loading />} />
            <Route path="/coupons-list" element={<CouponsList />} />
            <Route path="*" element={<CouponsList />} />

          </Routes>
        </BrowserRouter>
      </div>
    );
  }*/
}

export default App;
